<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Send Notification To All Contractors</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-xl flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    #notificationForm="ngForm"
    class="flex flex-column gap-spacing-xl">
    <div class="form-group">
      <input
        id="title"
        ngModel
        required
        name="title"
        type="text"
        placeholder="Notification Title"
        pInputText />
    </div>

    <div class="form-group w-full">
      <textarea
        rows="5"
        cols="30"
        #description
        ngModel
        name="description"
        pTextarea
        required
        [autoResize]="true"
        value="''"
        placeholder="Type notification here">
      </textarea>
    </div>
  </form>

  <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs align-items-center">
    <i class="icon-warning-solid text-xl icon-warning-color"></i>
    <ul class="mb-0 pl-spacing-2xl">
      <li class="label-large-regular text-warning-color">This action will cause the application to be unavailable for a few minutes to assure mass notifications delivery.</li>
      <li class="label-large-regular text-warning-color">Please don’t close, use or reload nor refresh the Monitoring center until the task is completed.</li>
    </ul>
  </div>
</div>

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [isLoading]="loading"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    [disabled]="!notificationForm.valid || loading"
    label="Send Notification"
    (btnClick)="confirmAction()"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
